
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { KanbanState } from '../../../../kanban.model';
import { Card, CardAttribute, CardAttributeDefinition, CardAttributeDefinitionType } from '../../../../../backend/backendapi';
import { formatDateTime } from '../../../../../../util';

@Component({
  name: 'Attribute',
  components: {},
})
export default class Attribute extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly card!: Card;
  @Prop({ required: true })
  readonly definition!: CardAttributeDefinition;

  CardAttributeDefinitionType = CardAttributeDefinitionType; //required to be used in template, vue2 shortcoming
  formatDateTime = formatDateTime; //required to be used in template, vue2 shortcoming

  get attribute(): CardAttribute {
    if (!this.card.attributes) {
      this.card.attributes = [];
    }
    let attr = this.card.attributes.find(e => e.definitionId === this.definition.id);
    if (!attr) {
      attr = new CardAttribute({ id: 0, cardId: this.card.id!, definitionId: this.definition.id, value: '' });
    }
    return attr;
  }
}
